// extracted by mini-css-extract-plugin
export default {"suggestionWrapper":"KeywordsEditor_suggestionWrapper__4Q5QA","suggestionRow":"KeywordsEditor_suggestionRow__W86jB"};